import { ENV } from '@app/constants/env';
import { keycloakAuthProvider } from '@sdk-react-identity/keycloak';

export const authProvider = keycloakAuthProvider(
  { 
    realm: ENV.KEYCLOAK_REALM,
    clientId: ENV.KEYCLOAK_CLIENT_ID,
    url: ENV.KEYCLOAK_URL,
  },
  { 
    initOptions: { 
      onLoad: 'check-sso',  // Don't auto-redirect, user must click login
      pkceMethod: 'S256',   // Required by Keycloak patch
      flow: 'standard',     // Authorization code flow
      checkLoginIframe: false  // Disable iframe for SSO check to prevent refresh loops
    },
    authenticationTimeout: 5000 
  },
);
const { getToken } = authProvider;
// getToken().then(token => {
//   console.log(token);
// });
export { getToken };
